export default "<ion-app>\n  <ion-router-outlet>\n    <ion-router-outlet id=\"main\"></ion-router-outlet>\n\n  </ion-router-outlet>\n</ion-app>\n";